import { defineStore } from 'pinia'

import type { PadStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const usePadStore = defineStore('pad', {
  state: (): PadStore => ({
    loading: false,
    _hydratedMath: false,
    _hydratedEla: false,
    plansMath: null,
    plansEla: null,
    requestMath: { status: 'idle', requestId: 0 },
    requestEla: { status: 'idle', requestId: 0 },
    paceMath: null,
    paceEla: null,
    periodIndex: null,
    countdownExpired: true,
    modalFaq: false,
  }),
  actions,
  getters,
})
